import { render, staticRenderFns } from "./comp3.vue?vue&type=template&id=7d9c84c6"
import script from "./comp3.vue?vue&type=script&lang=js"
export * from "./comp3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports